import { Dropdown } from '../Dropdown';
import { ErrorText } from '../ErrorText';
import { InfoNote } from '../InfoNote';
import { InfoIcon } from '../../icons/InfoIcon';
import { DropdownColumn, ErrorRow, Label, NoticeRow, Row } from './TimeslotRow.styles';
import type { TimeslotRowProps } from './TimeslotRow.types';

export function TimeslotRow({
  label,
  timeslots,
  selectedTimeslot,
  onChange,
  timeslotPlaceholder = 'Time*',
  ariaLabelFormatter = (l) => `${l} time`,
  disabled,
  error,
  notice,
}: TimeslotRowProps) {
  const hasTimeslots = timeslots.length > 0;

  return (
    <Row data-disabled={disabled || undefined} data-no-timeslots={!hasTimeslots || undefined}>
      <Label>{label}</Label>
      {hasTimeslots && (
        <DropdownColumn>
          <Dropdown
            options={timeslots}
            value={selectedTimeslot}
            placeholder={timeslotPlaceholder}
            onChange={onChange}
            aria-label={ariaLabelFormatter(label)}
            disabled={disabled || !!notice}
            hasError={!notice && !!error}
          />
          {notice ? (
            <NoticeRow>
              <InfoNote text={notice} variant="info" icon={<InfoIcon size={18} />} />
            </NoticeRow>
          ) : (
            error && (
              <ErrorRow>
                <ErrorText>{error}</ErrorText>
              </ErrorRow>
            )
          )}
        </DropdownColumn>
      )}
    </Row>
  );
}
